import React, { useEffect, useState } from 'react';
import { ArrowBackIos } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { LightsZonesList } from '../../../templates/applications/lightsZones/lightsZonesList/lightsZonesList';
import { Header } from '../../../components/header/header';
import {
  StyledBackButtonNavigator,
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../../components/layout/main/mainStyles';
import Strings from '../../../i18n';
import { RightSideBar } from '../../../components/layout/rightSideBar/rightSideBar';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import { useGetLightsZonesByLocationMutation } from '../../../services/lightsZones/lightsZonesService';
import { ILightZone } from '../../../types/Lights/lightZoneInterfaces';
import { SingleDetailsLighZone } from '../../../templates/applications/lightsZones/lightsZonesList/singleDetailsLightZone/singleDetailsLightZone';
import { MultiDetailsLightZone } from '../../../templates/applications/lightsZones/lightsZonesList/MultiDetailsLightZone/MultiDetailsLightZone';

export const LightsZonesView = () => {
  const [selectionModel, setSelectionModel] = useState<any[]>([]);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.empty
  );

  const { locationId } = useParams();

  const [selectedLightsZones, setSelectedLightsZones] = useState<ILightZone[]>(
    []
  );

  const [openSideBar, setOpenSideBar] = useState(false);

  const [getLightsZonesByLocation, { isSuccess, data }] =
    useGetLightsZonesByLocationMutation();

  const closeSideBar = () => {
    setOpenSideBar(false);
  };

  const reloadTable = () => {
    if (locationId) {
      getLightsZonesByLocation(+locationId);
    }
  };

  const switchComponentToShowRightSideBar = () => {
    switch (sideBarOpenFor) {
      case viewRightSideBarEnum.singleDetailsLightsZones:
        return (
          <SingleDetailsLighZone
            lightZone={selectedLightsZones[0]}
            reloadTable={reloadTable}
            closeSideBar={closeSideBar}
          />
        );
      case viewRightSideBarEnum.multipleDetailsLightsZones:
        return (
          <MultiDetailsLightZone
            lightZones={selectedLightsZones}
            reloadTable={reloadTable}
            closeSideBar={closeSideBar}
          />
        );
      default:
        return <div />;
    }
  };
  const openRightSideBarForMethod = (method: number) => {
    setSideBarOpenFor(method);
    setOpenSideBar(true);
  };

  useEffect(() => {
    if (selectedLightsZones.length === 1) {
      openRightSideBarForMethod(viewRightSideBarEnum.singleDetailsLightsZones);
    } else if (selectedLightsZones.length > 1) {
      openRightSideBarForMethod(
        viewRightSideBarEnum.multipleDetailsLightsZones
      );
    } else {
      openRightSideBarForMethod(viewRightSideBarEnum.empty);
      setOpenSideBar(false);
    }
  }, [selectedLightsZones]);

  useEffect(() => {
    if (locationId) {
      getLightsZonesByLocation(+locationId);
    }
  }, []);

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <StyledBackButtonNavigator
                size="small"
                onClick={() => navigate(-1)}
              >
                <ArrowBackIos />
              </StyledBackButtonNavigator>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader align="center">
                {Strings.lightsZones.title}
              </StyledTitleHeader>
            </div>
            <div className="col-4 text-right" />
          </div>
        </StyledHeaderContainer>
      </Header>
      {locationId && (
        <LightsZonesList
          data={data || []}
          searchValue={searchValue}
          selectedLightsZones={selectedLightsZones}
          setSelectedLightsZones={setSelectedLightsZones}
          reloadTable={() => {
            getLightsZonesByLocation(+locationId);
          }}
        />
      )}
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          closeSideBar();
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
    </>
  );
};
